import React from "react";
import classNames from "classnames";
import * as c from "./pricingWave.module.scss";

const PricingWave = () => (
  <div className={classNames(c.line, c.ultrawideLine)}>
    <div className={c.leftpath}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 50 270   "
        fill="none"
        height="270"
        width="50"
        preserveAspectRatio="none"
      >
        <rect width="50" height="280" x="0" y="145" stroke="none" fill="#fcfafa"></rect>
        <path d="M 0 147.25 L 50 147.25" stroke="#C098F5" strokeWidth="38" vectorEffect="non-scaling-stroke" />
      </svg>
    </div>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 3500 350   " fill="none">
      <path
        d="M-12 132C4.31359 132 21.0638 128 38 128C52.0069 128 64.2561 132 78 132C107.104 132 135.723 132.262 164 128.222C174.061 126.785 186.999 124 196 124C208.973 124 219.403 116 232 116C254.151 116 292.033 107.985 312 99.1111C332.129 90.1649 359.482 96.2876 378 86C398.089 74.8392 428.986 84 450 84C498.982 84 543.993 115.57 588.889 131.111C613.325 139.57 643.859 149.699 666 162C676.143 167.635 690.878 169.306 702 171.778C707.348 172.966 729.137 178.421 732 182C741.654 194.068 781.203 188 796 188C820.876 188 845.497 181.324 868 180C893.093 178.524 916.651 152.072 937.778 140C960.228 127.171 986.047 116.686 1003.78 96C1018.74 78.5461 1043.24 54.2162 1065.78 47.7778C1085.5 42.1421 1105.06 40.4314 1126 35.7778C1148.12 30.8617 1175.17 34.1468 1196 24.8889C1201.29 22.5365 1220 28 1228 28C1240.94 28 1251.61 34.5425 1264 36C1278.14 37.6633 1301.1 54.8339 1314 62C1331.93 71.96 1368.18 60.8043 1385.78 55.7778C1425.58 44.406 1498.93 47.5998 1536 67.1111C1559.48 79.47 1584.4 86.0884 1610 91.7778C1634.22 97.1603 1655.28 115.217 1674 129.778C1689.66 141.955 1715.75 152 1736 152C1757.91 152 1777.07 164 1800 164C1824.09 164 1842.21 169.508 1866 164.222C1878.19 161.514 1889.63 159.248 1901.78 155.778C1912.9 152.601 1916.93 137.308 1926.22 132C1965.61 109.491 2014.79 111.575 2048.89 80.8889C2069.28 62.5382 2093.75 74.7756 2116 64.8889C2125.02 60.8815 2178.72 70.1741 2187.11 76.8889C2205.55 91.6432 2225.15 102.417 2246 114C2267.08 125.711 2290.15 126.972 2310 138C2328.02 148.009 2350.6 151.681 2367.11 164.889C2386.89 180.715 2431.82 172 2456 172C2477.83 172 2506.52 176.823 2526 166C2543.99 156.006 2567.41 143.91 2586 139.778C2607.73 134.95 2630.4 113.271 2652 112C2673.66 110.726 2696.6 101.377 2720 100C2729.31 99.4522 2739.14 92 2750 92C2763.29 92 2776.01 88 2790 88C2795.98 88 2828.79 89.9846 2832 94C2836.3 99.3809 2855.17 104 2862 104C2881.51 104 2910.93 114.577 2928 123.111C2944.39 131.308 2957.14 145.121 2975.11 151.111C2983.85 154.024 2994.07 156.971 3000.89 163.111C3010.7 171.94 3026.96 171.869 3038 178C3049.23 184.238 3053.98 193.55 3066 196.222C3090.62 201.694 3116.43 200 3142 200C3194.4 200 3241.74 180 3294 180C3343.79 180 3386.46 144 3436 144C3460.43 144 3484.1 132.238 3510 136.222C3530.14 139.32 3551.05 142.419 3568.22 154.222C3591.66 170.339 3597.27 199.811 3608.22 224.444C3641.24 298.734 3663.73 382.911 3668 464C3671.48 530.031 3723.77 584.116 3720 652C3718.92 671.436 3698.08 693.877 3681.56 701.778C3648.41 717.629 3603.56 718.188 3568 723.111C3510.55 731.066 3453.43 738.971 3396.44 749.778C3301.85 767.718 3205.16 791.126 3108.89 796C3038.63 799.558 2968.94 806.806 2899.11 815.111C2793.96 827.619 2688.26 833.748 2582.89 844C2214 879.892 1842.36 876 1472 876C1196.36 876 920.098 859.319 646.222 828.889C442.291 806.23 237.558 828.202 33.5555 813.778C-66.7686 806.684 -178.73 802.745 -273.111 764.222C-320.009 745.08 -340 701.914 -340 653.556C-340 598.393 -335.629 547.401 -327.111 492.889C-323.012 466.653 -305.784 442.946 -296.222 418.444C-288.785 399.386 -283.265 381.228 -272 364C-242.495 318.875 -205.066 275.126 -168 236C-144.676 211.38 -108.241 179.815 -72 176C-55.8662 174.302 -25.2045 151.613 -20 136"
        strokeWidth="0"
        strokeLinecap="round"
        stroke="transparent"
        fill="#fcfafa"
        transform="translate(0 64)"
      />

      <path
        d="M0 131C257 131 296 78.5001 420 78.5001C555.5 78.5001 632.5 186.5 784.5 186.5C936.5 186.5 999 27.5 1152 20C1305 12.5 1395 114.5 1395 180.5C1395 283.5 1239 254.5 1315.5 113C1377.67 -1.99979 1527 67.5002 1640 116C1753 164.5 1818.5 205.5 1948 123C2077.5 40.5002 2142.5 33.2303 2277.5 130C2458 259.385 2596.5 76.2404 2778.5 83.5C2960.5 90.7595 3001.5 205.5 3142 205.5C3277 205.5 3363.5 131 3500 131"
        stroke="url(#paint0_linear_2307_22608)"
        strokeWidth="38"
        vectorEffect="non-scaling-stroke"
        transform="translate(0 60)"
      />

      <defs>
        <linearGradient
          id="paint0_linear_2307_22608"
          x1="944.5"
          y1="53.5904"
          x2="1165.63"
          y2="607.977"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C098F5" />
          <stop offset="0.5" stopColor="#FAA4CD" />
          <stop offset="1" stopColor="#FFC9A3" />
        </linearGradient>
      </defs>
    </svg>
    <div className={c.rightpath}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 50 270   "
        fill="none"
        height="270"
        width="50"
        preserveAspectRatio="none"
      >
        <rect width="50" height="250" x="0" y="140" stroke="none" fill="#fcfafa"></rect>
        <path d="M 0 147.25 L 50 147.25" stroke="#FFC9A3" strokeWidth="38" vectorEffect="non-scaling-stroke" />
      </svg>
    </div>
  </div>
);

export default PricingWave;
